import { apiGet } from 'api';
import { GetConsulteeTeamsResponse } from '../../types';
import { GetConsulteeTeamsRequest } from 'types';

export const getFilterTeams = (
  request?: GetConsulteeTeamsRequest
): Promise<GetConsulteeTeamsResponse> => {
  return request?.parentOrganisationId
    ? apiGet<GetConsulteeTeamsResponse, GetConsulteeTeamsRequest>('allteams', request)
    : Promise.reject();
};
